import React, { useState } from "react";
import { Routes, Route, useNavigate, Link } from "react-router-dom";
import "./App.scss";
import CameraPage from "./CameraPage";
import AboutPage from "./AboutPage";
import ImpactReport from "./ImpactReport";

function HomePage() {
  const [inputValue, setInputValue] = useState("");
  const [selectedModel, setSelectedModel] = useState("gpt-4o");
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !isExiting) {
      setIsExiting(true);
      setTimeout(() => {
        navigate("/cam", {
          state: { question: inputValue, model: selectedModel },
        });
      }, 600);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <div className="App">
      <div className="content">
        <div className={`left-section${isExiting ? " slide-out-left" : ""}`}>
          <h1 className="title">Embodied Intelligence</h1>
          <p className="subtitle">
            Reveal the hidden cost of AI with your body.
          </p>

          <div className="input-section">
            <div className="model-selector">
              <span className="answered-by">Answered by</span>
              <select
                className="model-dropdown"
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
              >
                <option value="gpt-4o-mini">GPT-4o-mini (Easy)</option>
                <option value="gpt-5-mini">GPT-5-mini (Light)</option>
                <option value="gpt-4o">GPT-4o (Moderate)</option>
                <option value="gpt-5-pro">GPT-5-pro (Heavy)</option>
              </select>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Ask Anything..."
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className="question-input"
                />
                <button type="submit" className="submit-button">
                  ↵
                </button>
              </div>
            </form>

            {/* {showTip && (
              <div className="tip">
                tip: your question is a How question, can be answered by less
                energy consuming model. We recommend to try out GPT-4o preserve
                some energy^^.
              </div>
            )} */}
          </div>
        </div>

        <div className="right-section">
          <div className="circle-container">
            <svg className="circle-svg" viewBox="0 0 400 400">
              <circle
                cx="200"
                cy="200"
                r="180"
                fill="none"
                stroke="white"
                strokeWidth="2"
              />
              <circle
                className="orbiting-circle"
                r="15"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <animateMotion
                  dur="8s"
                  repeatCount="indefinite"
                  path="M 200,20 A 180,180 0 1,1 200,380 A 180,180 0 1,1 200,20"
                />
              </circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

function ReportTestPage() {
  return (
    <div style={{ background: "#376fe1", minHeight: "100vh" }}>
      <ImpactReport
        isOpen={true}
        onClose={() => {}}
        energyJ={85.7}
        question="Explain how quantum computing works"
        modelUsed="GPT-4o"
      />
    </div>
  );
}

function App() {
  return (
    <>
      <Link to="/about" className="about-link">About</Link>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cam" element={<CameraPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/report" element={<ReportTestPage />} />
      </Routes>
    </>
  );
}

export default App;
